//carrier temp 소수점 1자리 포함해서 "."이 없는 상태로 들어옴 소수점 넣어야함
export function convertCarrierTemp(temp) {
    if (!temp) return 0.0; 
    return parseFloat((temp).toFixed(1));
}
